import "./index.css";
import React from "react";
import { Switch } from "antd";

import type { SwitchProps } from "antd";

interface TypeSwitchExpandProps extends SwitchProps {}

/**
 * @name SwitchExpand antd <Switch/> 增加了自定义图标
 */
const SwitchExpand: React.FC<TypeSwitchExpandProps> = (props) => {
  return (
    <div className="switch-expand">
      <Switch {...props} />
      <div>{props.children}</div>
    </div>
  );
};

export default SwitchExpand;
